@import 'styles/mixins';
@import 'styles/variables';

.section {
  border-bottom: 1px solid $gray-20;

  &:last-of-type {
    margin-bottom: 12px;
  }

  > header {
    display: flex;
    align-items: center;
    max-width: 360px;
    padding: 12px;

    .sectionTitle {
      margin-right: 12px;
      white-space: nowrap;
    }

    .styleSummary {
      @include line-clamp;
      @include ui-sm-text;

      color: $gray-40;
      margin-left: auto;
    }

    .titleButton {
      @include ui-lg-bold;

      color: $almanac-black;
      display: flex;
      align-items: center;
      flex-grow: 1;
      margin-right: 12px;
      max-width: calc(100% - 32px);
      text-align: left;
    }

    button {
      margin-left: auto;

      svg {
        fill: $gray-50;
        color: $gray-50;
        margin-top: -4px;
        vertical-align: middle;
      }
    }
  }
}

.setting {
  @include ui-md-text;

  border-radius: 6px;
  color: $gray-50;
  display: flex;
  margin-bottom: 12px;
  max-height: 32px;
  overflow: visible;
  padding: 8px 12px;
  white-space: nowrap;

  &:hover {
    background-color: $gray-5;
  }

  &:focus-within {
    background-color: $gray-10;
  }

  .control {
    @include ui-md-text;

    align-content: center;
    color: $almanac-black;
    display: flex;
    margin-left: auto;

    input {
      @include ui-md-text;

      color: $almanac-black;
      margin-right: -7px;
      margin-top: -7px;
      padding: 5px 8px;
      text-align: right;

      &:focus {
        border-radius: 4px;
        border: 1px solid var(--focus-10);
        caret-color: var(--focus-50);
        box-shadow: 0 0 0 3px var(--focus-glare), inset 0 0 0 1px var(--focus-50);
        margin-right: -8px;
        margin-top: -8px;
      }
    }

    .controlDropdown {
      @include hide-scrollbar;

      max-height: 400px;
      overflow: auto;
      right: -12px;
      top: calc(100% + 8px);
    }

    .colorPicker {
      right: -12px;
    }

    .fontDropdown {
      ul > li {
        height: 28px;

        img {
          bottom: -2px;
          position: relative;
        }
      }
    }

    button {
      white-space: nowrap;
    }

    button.removeColor {
      @include ui-sm-text;

      margin-right: 8px;
    }

    .noColor {
      left: -2px;
      position: relative;
      stroke: $gray-30;
      top: -2px;
    }

    .colorPreview {
      border: 1px solid $gray-20;
      border-radius: 50%;
      height: 20px;
      left: -2px;
      position: relative;
      top: -2px;
      width: 20px;
    }
  }
}

.semibold {
  font-weight: 600;
}

.labelIcon {
  fill: $gray-40;
  margin: -4px 8px -4px 0;

  &.shortLabelIcon {
    fill: $almanac-black;
    margin-right: 0;
  }
}
